import * as React from 'react';
import { VILLAGE_CLASSES } from '../../../../constants/filters';
import { EVillageClass } from '../../../../types/filters';
import { Select } from '../../../Select';

interface IVillageClassProps {
  value: EVillageClass[];
  onChange(value: EVillageClass[]): void;
}

export const VillageClass: React.FC<IVillageClassProps> = ({ value, onChange }) => {
  return (
    <Select
      multiple
      allowEmpty={false}
      placeholder="Класс"
      options={VILLAGE_CLASSES}
      value={value}
      onChange={onChange}
      buttonParams={{ label: 'Класс объекта' }}
    />
  );
};
